import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";


export const MeteringRecordsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListMeteringRecords') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateMeteringRecord') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/metering-records'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetMeteringRecord') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/metering-records'/>
                    )
                }

            >
            </Route>


        </Routes>
    );
};
